const Message = ({ variant = 'info', children }) => {
  const getVariantClasses = () => {
    switch (variant) {
      case 'danger':
      case 'error':
        return 'bg-danger/10 text-danger border-danger/30';
      case 'success':
        return 'bg-success/10 text-success border-success/30';
      case 'warning':
        return 'bg-accent/10 text-accent border-accent/30';
      case 'info':
      default:
        return 'bg-white/[.04] text-body border-white/12';
    }
  };

  return (
    <div className={`p-4 mb-4 rounded-btn border ${getVariantClasses()}`}>
      {children}
    </div>
  );
};

export default Message;
